/** Рулетка: состояние и вращение. Приз выбирает сервер. */
import { useQuery } from '@tanstack/react-query';

import { apiGet, apiPost } from '@/shared/api/client';
import { wheelSchema, wheelSpinSchema } from '@/shared/api/schemas';
import { isGuest } from '@/shared/lib/guest';

export function useWheel() {
  return useQuery({
    queryKey: ['wheel'],
    queryFn: () => apiGet('/wheel', wheelSchema),
    enabled: !isGuest(),
  });
}

export function spinWheel() {
  return apiPost('/wheel/spin', {}, wheelSpinSchema);
}

/** Цена со скидкой — как на сервере (packages/domain/wheel/policy.py). */
export function discountedMinor(amount: number, currency: string, percent: number): number {
  const value = (amount * (100 - percent)) / 100;
  return Math.max(1, currency === 'XTR' ? Math.ceil(value) : Math.round(value));
}

export function spinsWord(n: number): string {
  const tail = n % 100;
  const last = n % 10;
  if (tail >= 11 && tail <= 14) return 'вращений';
  if (last === 1) return 'вращение';
  if (last >= 2 && last <= 4) return 'вращения';
  return 'вращений';
}
